var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column"},[(_vm.visible)?_c('div',{staticClass:"ml-auto"},[_c('pre',{style:({ maxHeight: '400px', maxWidth: '400px', overflow: 'scroll' })},[_vm._v(_vm._s(JSON.stringify(_vm.$jss.sitecoreContext(), null, 2)))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }